import { useParams, usePathname } from 'next/navigation';

// Utils
import { formatUrlPathname } from '@/utils/urls/formatUrl';

import { DropdownLinksType } from '@/components/layouts/LayoutPlatform/components/PageHeaderRecap';
// Components
import { PopoverList } from '@/components/layouts/LayoutPlatform/components/PageHeaderRecap/PopoverList';

type PageHeaderPopoverProps = {
    dropdownLinks: DropdownLinksType;
};

export function PageHeaderPopover({ dropdownLinks }: PageHeaderPopoverProps) {
    const pathname = usePathname();
    const params = useParams();

    return (
        <div className="relative z-10 mb-8 flex items-center gap-3">
            <PopoverList links={dropdownLinks} />
            <h2 className="font-GBold text-2xl @[500px]/wrapper-platform-content:text-3.5xl">
                {
                    dropdownLinks.find((link) => formatUrlPathname(link.href, params) === pathname)
                        ?.label
                }
            </h2>
        </div>
    );
}
